import { Navigate, useLocation } from 'react-router-dom';
import { useContext } from "react";
import { AuthContext } from '../../contexts/auth';
import { DefaultViews, RoleBasedViews } from '../../pages/views';

const ProtectedRoute = () => {
    const { user } = useContext(AuthContext);
    const location = useLocation();


    const findRouteComponent = (routes, pathname) => {
        // First check direct routes
        if (routes[pathname]) {
            return routes[pathname].component;
        }

        // Then check for nested routes
        for (const route of Object.values(routes)) {
            if (route.children) {
                const childRoute = route.children.find(child => child.path === pathname);
                if (childRoute) {
                    return childRoute.component;
                }
            }
        }

        return null;
    };

    const component = findRouteComponent(RoleBasedViews[user.roles[0]].routes, location.pathname);



    try {
        // return RoleBasedViews[user.roles[0]].routes[location.pathname].component ;
        return findRouteComponent(RoleBasedViews[user.roles[0]].routes, location.pathname)
    } catch {
        try {
            return DefaultViews[location.pathname].component;
        } catch {
            return <Navigate to='/403' />;
        };
    };

}

export { ProtectedRoute };